<template>
  <div class="col-md-12">
    <div class="card card-container">
      <h3>Nulstil adgangskode</h3>
      <p>
        Indtast din e-mail adresse herunder så sender vi en vejledning til
        hvordan du kan nulstille din adgangskode.
      </p>
      <form @submit.prevent="forgot">
        <div class="form-group">
          <label for="email">E-mail</label>
          <input
            name="email"
            id="email"
            type="email"
            class="form-control"
            v-model="email"
          />
        </div>

        <div class="form-group mt-3">
          <button class="btn btn-primary btn-block" :disabled="loading">
            <span
              v-show="loading"
              class="spinner-border spinner-border-sm"
            ></span>
            <span>Send vejledning</span>
          </button>
        </div>

        <div class="form-group mt-3">
          <div v-if="message" class="alert alert-danger" role="alert">
            {{ message }}
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import AuthService from '../services/auth.service';

export default {
  name: 'Forgot',
  components: {},
  data() {
    return {
      email: '',
      loading: false,
      message: '',
    };
  },
  methods: {
    forgot() {
      this.loading = true;

      AuthService.forgot(this.email)
        .then(() => {
          window.location = '/';
        })
        .catch(() => {
          this.loading = false;
          this.message =
            'Der opstod en fejl. Kontakt KL hvis fejlen fortsætter.';
        });
    },
  },
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

.error-feedback {
  color: red;
}
</style>
